<template>
    <div>
        <div class="adv">
            <div class="ad-tt">ad</div>
            <div id='div-gpt-ad-1765264142143-0' style='min-width: 300px; min-height: 100px;'></div>
        </div>
    </div>
</template>
<script setup>
import { onMounted } from "vue"
onMounted(() => {
    if (typeof googletag !== 'undefined') {
        googletag.cmd.push(function () { googletag.display('div-gpt-ad-1765264142143-0'); });
    }
})
</script>
<style>
.adv {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5px 0;
}

.ad-tt {
    width: 100%;
    text-align: center;
}
</style>